module.exports = __webpack_public_path__ + "static/img/cert-auth-2.30f2b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cert-auth-2.png
// module id = Q4Re
// module chunks = 0